// src/features/resource/resourceReducer.js
import { createReducer } from '@reduxjs/toolkit';
import {
    clearMessages,
    getResourceCategoryStart, getResourceCategorySuccess, getResourceCategoryFailure,
    getResourcesStart, getResourcesSuccess, getResourcesFailure,
    getResourceDetailsStart, getResourceDetailsSuccess, getResourceDetailsFailure,
    getResourceYearsStart, getResourceYearsSuccess, getResourceYearsFailure,
} from './resourceActions';

const initialState = {
    resourceCategories: null,
    resources: null,
    resourceDetails: null,
    resourceYears: null,
    loading: false,
    successMessage: null,
    errorMessage: null,
};

const resourceReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(clearMessages, (state) => {
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getResourceCategoryStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getResourceCategorySuccess, (state, action) => {
            state.loading = false;
            state.resourceCategories = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(getResourceCategoryFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        })
        .addCase(getResourcesStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getResourcesSuccess, (state, action) => {
            state.loading = false;
            state.resources = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(getResourcesFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        })
        .addCase(getResourceDetailsStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getResourceDetailsSuccess, (state, action) => {
            state.loading = false;
            state.resourceDetails = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(getResourceDetailsFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        })
        // Resource Years Cases
        .addCase(getResourceYearsStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(getResourceYearsSuccess, (state, action) => {
            state.loading = false;
            state.resourceYears = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(getResourceYearsFailure, (state, action) => {
            state.loading = false;
            state.errorMessage = action.payload.message;
        });
});

export default resourceReducer;
